module.exports = __webpack_public_path__ + "media/images/logo-mobile-bfd69b042d29e1d5346a43c17231fda7.svg";